import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import { FaShip } from 'react-icons/fa';
// import { FaShip, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import GOHLogo from './assets/goh-logo.png';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #1c4e8c;
  padding: 5px 40px;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 10px 20px; /* Smaller padding on mobile */
  }  
`;

const LogoContainer = styled.div`
  background-color: white; /* White background */
  padding: 10px; /* Optional padding for spacing */
  border-radius: 8px; /* Optional for rounded corners */
  display: flex;
  align-items: center;
  justify-content: center;
`;


const Logo = styled.img`
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.1);
  }
   
  @media (max-width: 768px) {
    height: 40px; /* Smaller logo for mobile */
  }  
`;

const NavLinks = styled.nav`
  display: flex;
  gap: 25px;

  @media (max-width: 768px) {
    gap: 15px; /* Reduce gap for smaller screens */
  }  
`;

const NavButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  font-weight: bold;
  color: white;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  padding: 8px 12px;
  border-radius: 8px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: scale(1.07);
  }

  svg {
    font-size: 22px;
  }

  @media (max-width: 768px) {
    font-size: 16px; /* Slightly smaller text */
    padding: 6px 10px;
  }  
`;

const Content = styled.main`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 10px; /* Less padding for mobile */
  }  
`;

const Footer = styled.footer`
  background-color: #1c4e8c;
  padding: 25px 20px;
  color: white;
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 5px;
  box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 12px; /* Smaller font size for mobile */
    padding: 15px;
  }  

    @media (min-width: 1600px) {
    font-size: 12px;
    padding: 5px
  }


`;

const FooterText = styled.p`
  margin: 4px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    font-size: 16px;
  }
`;

const Layout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('userData');
    navigate('/');
  };



  return (
    <LayoutContainer>
      {/* 🟦 Navbar/Header */}
      <Header>

        
        <LogoContainer>
          <Logo 
              src={GOHLogo} 
              alt="GOH Logo" 
              onClick={() => window.location.href = "https://www.goh.co.il/"} 
              style={{ cursor: "pointer" }} 
          />
      </LogoContainer>

        <NavLinks>
          {/* 🚀 Show only if user ID is 8 */}
          {JSON.parse(localStorage.getItem('userData'))?.Cust_Code === "10019" && (
            <NavButton onClick={() => navigate('/customer-movements')}>
              📄 תנועות לקוחות
            </NavButton>
          )}

          <NavButton onClick={() => navigate('/warehouses')}>
            <FaShip /> אוניות
          </NavButton>

          <NavButton onClick={handleLogout}>
            <FiLogOut /> התנתק
          </NavButton>
        </NavLinks>
      </Header>

      {/* 📄 Main Content */}
      <Content>{children}</Content>

      {/* 🔵 Footer */}
      <Footer>
        <FooterText>© 2025 GOH - כל הזכויות שמורות</FooterText>
        <FooterText>ג'י אמ אס טק בע"מ - פתרונות תוכנה</FooterText>
        {/* <FooterText>
          <FaPhoneAlt /> טלפון: 03-1234567 | <FaEnvelope /> אימייל: support@gmstech.co.il
        </FooterText> */}
      </Footer>
    </LayoutContainer>
  );
};

export default Layout;
